import { listClasses } from '@mui/material/List'
import { CssVarsThemeOptions } from '@mui/material/styles'

import { paper } from '../../css'

// ----------------------------------------------------------------------

export function popover(): CssVarsThemeOptions['components'] {
	return {
		MuiPopover: {
			styleOverrides: {
				paper: ({ theme }) => ({
					...paper({ theme, dropdown: true }),
					[`& .${listClasses.root}`]: {
						paddingTop: 0,
						paddingBottom: 0,
					},
				}),
			},
		},
	}
}
